/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateNotificationScheduleRequest
 */
export interface CreateNotificationScheduleRequest {
    /**
     *
     * @type {string}
     * @memberof CreateNotificationScheduleRequest
     */
    scheduleType?: CreateNotificationScheduleRequestScheduleTypeEnum;
    /**
     *
     * @type {string}
     * @memberof CreateNotificationScheduleRequest
     */
    scheduledTime?: string;
    /**
     *
     * @type {number}
     * @memberof CreateNotificationScheduleRequest
     */
    daysOfWeek?: number;
    /**
     *
     * @type {number}
     * @memberof CreateNotificationScheduleRequest
     */
    dayOfMonth?: number;
    /**
     *
     * @type {number}
     * @memberof CreateNotificationScheduleRequest
     */
    intervalValue?: number;
    /**
     *
     * @type {string}
     * @memberof CreateNotificationScheduleRequest
     */
    intervalUnit?: CreateNotificationScheduleRequestIntervalUnitEnum;
    /**
     *
     * @type {string}
     * @memberof CreateNotificationScheduleRequest
     */
    timeZone?: string;
}

/**
 * @export
 */
export const CreateNotificationScheduleRequestScheduleTypeEnum = {
    Daily: "Daily",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Interval: "Interval",
} as const;
export type CreateNotificationScheduleRequestScheduleTypeEnum =
    (typeof CreateNotificationScheduleRequestScheduleTypeEnum)[keyof typeof CreateNotificationScheduleRequestScheduleTypeEnum];

/**
 * @export
 */
export const CreateNotificationScheduleRequestIntervalUnitEnum = {
    Minutes: "Minutes",
    Hours: "Hours",
    Days: "Days",
    Weeks: "Weeks",
    Months: "Months",
} as const;
export type CreateNotificationScheduleRequestIntervalUnitEnum =
    (typeof CreateNotificationScheduleRequestIntervalUnitEnum)[keyof typeof CreateNotificationScheduleRequestIntervalUnitEnum];

/**
 * Check if a given object implements the CreateNotificationScheduleRequest interface.
 */
export function instanceOfCreateNotificationScheduleRequest(
    value: object,
): value is CreateNotificationScheduleRequest {
    return true;
}

export function CreateNotificationScheduleRequestFromJSON(
    json: any,
): CreateNotificationScheduleRequest {
    return CreateNotificationScheduleRequestFromJSONTyped(json, false);
}

export function CreateNotificationScheduleRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateNotificationScheduleRequest {
    if (json == null) {
        return json;
    }
    return {
        scheduleType:
            json["scheduleType"] == null ? undefined : json["scheduleType"],
        scheduledTime:
            json["scheduledTime"] == null ? undefined : json["scheduledTime"],
        daysOfWeek: json["daysOfWeek"] == null ? undefined : json["daysOfWeek"],
        dayOfMonth: json["dayOfMonth"] == null ? undefined : json["dayOfMonth"],
        intervalValue:
            json["intervalValue"] == null ? undefined : json["intervalValue"],
        intervalUnit:
            json["intervalUnit"] == null ? undefined : json["intervalUnit"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
    };
}

export function CreateNotificationScheduleRequestToJSON(
    value?: CreateNotificationScheduleRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        scheduleType: value["scheduleType"],
        scheduledTime: value["scheduledTime"],
        daysOfWeek: value["daysOfWeek"],
        dayOfMonth: value["dayOfMonth"],
        intervalValue: value["intervalValue"],
        intervalUnit: value["intervalUnit"],
        timeZone: value["timeZone"],
    };
}
